import { render } from "./FormAlt.vue?vue&type=template&id=5f86030a&scoped=true"
import script from "./FormAlt.vue?vue&type=script&lang=js"
export * from "./FormAlt.vue?vue&type=script&lang=js"

import "./FormAlt.vue?vue&type=style&index=0&id=5f86030a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f86030a"

export default script